import styled from "@emotion/styled"
import { Box, Dialog, Grid, Typography } from "@mui/material"
import * as api from "api"
import CloseButton from "common/CloseButton"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import ContactUsButton from "components/ContactUs/ContactUsButton"
import VehicleFinishingLevelCategories from "components/Vehicle/VehicleFinishingLevelCategories"
import VehicleFreeOptions from "components/Vehicle/VehicleFreeOptions"
import VehicleMissons, { TagLarge } from "components/Vehicle/VehicleMissons"
import VehicleNotices from "components/Vehicle/VehicleNotices"
import VehiclePrice, { PriceDialog } from "components/Vehicle/VehiclePrice"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    padding-bottom: 28px;
    text-align: center;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .image {
      height: 253px;
      width: 395px;
    }

    .left {
      padding: 35px 42px 63px 0;
      text-align: left; // flipped by mui
    }

    ${PriceDialog}
    ${TagLarge}
  `,
  Main: styled.div`
    padding-top: 28px;
    overflow-y: overlay;
    flex: 1;
  `,
  Pad: styled.div`
    padding: 0 47px;
  `,
  Title: styled(Typography)`
    font-size: 34px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
  `,
  BodyStyle: styled(Typography)`
    font-weight: bold;
    color: ${(p) => p.theme.colors.bluishGrey};
    font-size: 24px;
    margin: 7px 0 20px;
  `,
  Dialog: styled(Dialog)`
    .MuiDialog-paper {
      max-width: 895px;
    }
  `,
}

type VehicleChildDialogDesktopProps = {
  onClose: () => void
  data: api.VehicleChildren | api.VehicleFinishingLevel
  type: api.FamilyTypes
  modelId: number
}

const VehicleChildDialogDesktop = ({
  onClose,
  data,
  type,
  modelId,
}: VehicleChildDialogDesktopProps) => (
  <Styled.Dialog open={data != null} onClose={onClose} fullWidth>
    {data != null && (
      <Styled.Wrapper>
        <CloseButton onClick={onClose} />
        <Styled.Main>
          <Styled.Pad>
            <Styled.Title>
              {data.name}
              {!api.Types.isFinishingLevel(data, type) &&
                ` | L${data.industryCodeLength}H${data.industryCodeHeight}`}
            </Styled.Title>
            <Styled.BodyStyle>{data.bodyStyle}</Styled.BodyStyle>
            <Shared.SimpleDivider />
            <VehicleFreeOptions data={data.freeOptions} />
            <Grid container>
              <Grid item md={6}>
                <div className="image">
                  <RatioElement ratio={16 / 9}>
                    <ResponsiveModelImage
                      image={data.image}
                      imageSizes="395px"
                    />
                  </RatioElement>
                </div>
              </Grid>
              <Grid item md={6} className="left">
                <VehicleMissons data={data.missions} />
                {data.displayPriceWithoutVat && (
                  <VehiclePrice price={data.priceWithoutVAT} vat={false} />
                )}
                <VehiclePrice price={data.priceWithVAT} vat={true} />
                <VehicleNotices type="VehicleChild" data={data} />
              </Grid>
            </Grid>
          </Styled.Pad>
          {api.Types.isFinishingLevel(data, type) && (
            <VehicleFinishingLevelCategories data={data.categories} />
          )}
        </Styled.Main>

        <Box flexShrink={1}>
          <Styled.Pad>
            <ContactUsButton label="קביעת פגישה עם נציג" modelId={modelId} />
          </Styled.Pad>
        </Box>
      </Styled.Wrapper>
    )}
  </Styled.Dialog>
)

export default memo(VehicleChildDialogDesktop)
